import styled from 'styled-components';

export const OrgSwitcherWrapper = styled.div`
  position: relative;
  margin-bottom: 12px;
`;

export const OrgSwitcherLabel = styled.div`
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.settings.textColor};
  opacity: 0.7;
  margin-bottom: 4px;
`;

export const OrgSwitcherButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  background: ${({ theme }) => theme.settings.whiteColor};
  cursor: ${({ $interactive }) => ($interactive ? 'pointer' : 'default')};
  transition: background 0.2s ease;
  min-width: 0;

  &:hover {
    background: ${({ theme, $interactive }) =>
      $interactive ? theme.settings.bodyBg : theme.settings.whiteColor};
  }
`;

export const OrgSwitcherName = styled.div`
  flex: 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  color: ${({ theme }) => theme.settings.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const OrgSwitcherMenu = styled.div`
  position: absolute;
  top: calc(100% - 6px);
  left: 0;
  right: 0;
  background: ${({ theme }) => theme.settings.whiteColor};
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  z-index: 1002;
  max-height: 280px;
  overflow-y: auto;
`;

export const OrgSwitcherMenuItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  cursor: pointer;
  color: ${({ theme, $active }) =>
    $active ? theme.settings.primary : theme.settings.secondary};
  background: ${({ theme, $active }) =>
    $active ? theme.settings.bodyBg : 'transparent'};

  &:hover {
    background: ${({ theme }) => theme.settings.bodyBg};
  }

  span.orgName {
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const OrgSwitcherEmpty = styled.div`
  padding: 10px 12px;
  font-size: 12px;
  color: ${({ theme }) => theme.settings.textColor};
`;

export const OrgSwitcherCollapsed = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $inline }) => ($inline ? '32px' : '36px')};
  height: ${({ $inline }) => ($inline ? '32px' : '36px')};
  margin: ${({ $inline }) => ($inline ? '0 0 0 4px' : '0 auto 12px')};
  flex: 0 0 auto;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  background: ${({ theme }) => theme.settings.whiteColor};
  color: ${({ theme }) => theme.settings.primary};
  font-size: 12px;
  font-weight: 600;
  cursor: default;
`;
